async function fetchImageBinaryData(imageUrl) {
    try {
      const response = await fetch(imageUrl);
  
      if (!response.ok) {
        throw new Error(`Failed to fetch image: ${response.statusText}`);
      }
  
      const imageBlob = await response.blob();
      return imageBlob;
    } catch (error) {
      console.error("Error fetching image:", error);
      throw error;
    }
  }

  export default fetchImageBinaryData;